import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=62f4ac7f&scoped=true&"
import script from "./Loyalty.vue?vue&type=script&lang=ts&"
export * from "./Loyalty.vue?vue&type=script&lang=ts&"
import style0 from "./Loyalty.vue?vue&type=style&index=0&id=62f4ac7f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4ac7f",
  null
  
)

export default component.exports